import { CategorieDto } from '@resources/resources';
import { ICategoriesWebServiceClient, ArticleDto } from '@resources/resources';
import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';

@Injectable()
export class CategorieResolver implements Resolve<CategorieDto> {

  constructor(private categorieWebService: ICategoriesWebServiceClient) { }

  resolve(route: ActivatedRouteSnapshot) {
    let categorieId: number = Number(route.paramMap.get('id'));
    return this.categorieWebService.recupererCategorie(categorieId);
  }
}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-commande-materiel/digicerba-commande-materiel-web/src/angular/cerba/src/app/pages/cerba/pages/categories/gestion-articles/categorie.resolver.ts